/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState, useEffect } from 'react';
import PortfolioSummaryContent from './PortfolioSummaryContent';
import useMounted from '../../shared/useMount/useMount';
import IEnergyManagementProps, {
  IEuiData,
  IEuiResponse
} from '../IEnergyManagementProps';
import {
  getEuiCalculationDate,
  dataAvailableCheck
} from '../../shared/Utils/Utils';
import useConnectorAndDynamicProps from '../../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import { euiStatus } from '../../shared/Utils/Constants';

const PortfolioSummaryComponent = (props: IEnergyManagementProps) => {
  const { bearerToken, requestContext } = props;

  const connectorConfig = {
    name: 'eui-site',
    options: {
      currentDate: getEuiCalculationDate()
    }
  };

  const isMounted = useMounted();

  const [dataConnector] = useConnectorAndDynamicProps({
    connectorConfig,
    requestContext,
    bearerToken
  });

  useEffect(() => {
    if (isMounted) {
      setData({} as IEuiData);
      dataConnector && dataConnector.actions && dataConnector.actions.getAll();
    }
  }, [requestContext]);

  const { all, loading, error, status } = dataConnector.data;
  const portfolioSummary = (all as unknown) as IEuiResponse;
  const isDataAvailable = dataAvailableCheck(portfolioSummary);

  const [data, setData] = useState({} as IEuiData);
  const [euiMessage, setEuiMessage] = useState('');
  useEffect(() => {
    if ((isDataAvailable || error || status) && !loading) {
      if (isDataAvailable) {
        setData((portfolioSummary && portfolioSummary.data) || {});
        setEuiMessage(
          portfolioSummary.status === euiStatus.SUCCESS
            ? ''
            : portfolioSummary.message
        );
      }
    }
  }, [isDataAvailable, loading]);

  return (
    <PortfolioSummaryContent
      data={data}
      message={euiMessage}
      requestContext={requestContext}
    />
  );
};
export default PortfolioSummaryComponent;
